import React, { useState } from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import Pagination from "../../components/Pagination/pagination"
import ContenuLibre from "../../components/ContenuLibre/contenu-libre"
import {
  listEventsContainer,
  listEvents,
  eventsContainer,
  eventsItem,
  zoneEventsLibreHaut,
  zoneEventsLibreBas,
  eventsFilters,
  eventsFilterByPeriod,
  eventsFilterByTaxo,
  eventsFiltersTaxo,
  eventsFiltersTaxoActive,
  eventsFilterDelete,
} from "./styles/listEvents.module.scss"
import PropTypes from "prop-types"
import {
  ContainerLight,
  EventsItem,
  BorderTaxo,
  StyledFade,
} from "./styled-components/evenements-styled"
import SEO from "../../components/seo"
import EvenementItem from "./listItems/evenement-item"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query($skip: Int!, $limit: Int!) {
    allTaxonomyTermThematiques {
      ...ListEventsTaxo
    }
    allPublishedTaxos: allTaxonomyTermThematiques(
      filter: {
        relationships: {
          node__evenements: { elemMatch: { status: { eq: true } } }
        }
      }
    ) {
      ...ListEventsTaxo
    }
    allNodeEvenements(
      sort: { fields: field_date_de_debut, order: ASC }
      limit: $limit
      skip: $skip
    ) {
      ...ListEvents
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Parent component---------------------------//

const EvenementsTemplate = ({ data, pageContext }) => {
  const pageTitle = "Liste des évènements"
  const allTaxos = data.allPublishedTaxos.edges
    .map(({ node }) => {
      return node.name
    })
    .join()
  return (
    <Layout message={pageTitle}>
      <SEO
        title={pageTitle}
        description={
          "Dans cette page, vous découvrez tous les évènements, mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
      />
      <StyledFade childClassName={listEvents} delay={150}>
        <section className={zoneEventsLibreHaut}>
          <ContenuLibre zoneTaxoLibre="zone_evenements_haut" />
        </section>
        <Filtres pageContext={pageContext} eventsData={data} />
        <ContainerLight className={zoneEventsLibreBas}>
          <ContenuLibre zoneTaxoLibre="zone_evenements_bas" />
        </ContainerLight>
      </StyledFade>
    </Layout>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const Filtres = ({ eventsData, pageContext }) => {
  const taxoData = eventsData.allPublishedTaxos.edges
  const [chooseTaxo, setChooseTaxo] = useState("")
  return (
    <>
      <ContainerLight className={eventsFilters}>
        <div className={eventsFilterByTaxo}>
          <h3>Types d&apos;évènement(s) : </h3>
          {taxoData.map(({ node }) => {
            let taxoActiveClass = false
            if (chooseTaxo === node.name) {
              taxoActiveClass = true
            }
            return (
              <React.Fragment key={node.drupal_id}>
                <BorderTaxo
                  activeBool={taxoActiveClass}
                  activeText={"#fff"}
                  tabIndex={0}
                  role="button"
                  className={
                    taxoActiveClass
                      ? eventsFiltersTaxoActive
                      : eventsFiltersTaxo
                  }
                  onClick={() => {
                    if (chooseTaxo === "" || chooseTaxo !== node.name) {
                      setChooseTaxo(node.name)
                    } else if (chooseTaxo === node.name) {
                      setChooseTaxo("")
                    }
                  }}
                  onKeyDown={() => {
                    if (chooseTaxo === "" || chooseTaxo !== node.name) {
                      setChooseTaxo(node.name)
                    } else if (chooseTaxo === node.name) {
                      setChooseTaxo("")
                    }
                  }}
                >
                  {node.name}
                </BorderTaxo>
              </React.Fragment>
            )
          })}
        </div>
        <div className={eventsFilterByPeriod}></div>
        <div className={eventsFilterDelete}></div>
      </ContainerLight>
      <FiltreEvenement
        eventsData={eventsData}
        taxoChoisie={chooseTaxo}
        pageContext={pageContext}
      />
    </>
  )
}

//-----------------------Child component---------------------------//

//-----------------------Sub-Child component---------------------------//

const FiltreEvenement = ({ eventsData, pageContext, taxoChoisie }) => {
  const { currentPage, numPages, baseLink } = pageContext
  let filteredData = []
  filteredData = eventsData.allNodeEvenements.edges.reduce((acc, node) => {
    let matchingTaxo = []
    matchingTaxo = node.node.relationships.field_taxonomie_thematique.filter(
      (taxo) => taxo.name === taxoChoisie
    )
    if (matchingTaxo.length > 0) {
      acc.push(node)
    }
    return acc
  }, [])
  return (
    <>
      <section className={listEventsContainer}>
        <div className={eventsContainer}>
          <RenderEvenements
            taxoChoisie={taxoChoisie}
            eventsData={eventsData}
            filteredData={filteredData}
          />
        </div>
        <Pagination
          currentPage={currentPage}
          numPages={numPages}
          contextPage={baseLink}
        />
      </section>
    </>
  )
}

//-----------------------Sub-Child component---------------------------//

//-----------------------Sub-Sub-Child component---------------------------//

const RenderEvenements = ({ eventsData, filteredData, taxoChoisie }) => {
  const events =
    taxoChoisie === "" ? eventsData.allNodeEvenements.edges : filteredData
  return (
    <>
      {events.map(({ node }) => (
        <EventsItem key={node.title} className={eventsItem}>
          <EvenementItem taxoChoisie={taxoChoisie} evenement={node} />
        </EventsItem>
      ))}
    </>
  )
}

//-----------------------Sub-Sub-Child component---------------------------//

//-----------------------Prop-Types---------------------------//

EvenementsTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
}
RenderEvenements.propTypes = {
  eventsData: PropTypes.object.isRequired,
  filteredData: PropTypes.array.isRequired,
  taxoChoisie: PropTypes.string.isRequired,
}
FiltreEvenement.propTypes = {
  eventsData: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
  taxoChoisie: PropTypes.string.isRequired,
}
Filtres.propTypes = {
  eventsData: PropTypes.object.isRequired,
  pageContext: PropTypes.object,
}

//-----------------------Prop-Types---------------------------//

export default EvenementsTemplate
